<template>
    <div>
        <pageheading/>
        <div class="uk-padding">
            <div class="uk-container">
               <div class="uk-child-width-1-2@m" uk-grid>
                   <div>
                       <h2 class="uk-heading-bullet">Offices</h2>
                       <ul class="uk-list uk-list-bullet">

                           <li class="uk-text-primary">Office Of the President</li>
                           <li><router-link to="/academicadvisement"> Academic Advisement & Student Success</router-link></li>
                           <li><router-link to="/graduatestudies"> Research & Graduate Studies</router-link></li>
                           <!--<li><router-link to="/">Research & Graduate Studies</router-link></li>-->

                           <li><router-link to="/scholarshipandstudentaid"> Scholarship and Student Aid</router-link></li>
                           <!--<li><router-link to="/studentfinance"> Student Finance</router-link></li>-->
                           <li><router-link to="/studentengagementandretention"> Student Engagement & Retention</router-link></li>
                           <!--<li><router-link to="/uniss"> University Information System Services</router-link></li>-->
                           <li><router-link to="/records"> University Records</router-link></li>
                       </ul>
                   </div>
                   <div>
                       <h2 class="uk-heading-bullet">Departments</h2>
                       <ul class="uk-list uk-list-bullet">


                           <li><router-link to="/ccmpr"> Corporate Communications, Marketing and Public Relations</router-link></li>

                           <li><router-link to="/publicsafety"> Campus Safety and Security Department</router-link></li>
                           <li><router-link to="/scholarshipandstudentaid"> Scholarship and Student Aid</router-link></li>
                           <li><router-link to="/studentfinance">Student Finance</router-link></li>
                          <!-- <li><router-link to="/studentengagementandretention"> Student Engagement & Retention</router-link></li>-->
                           <li><router-link to="/uniss">University Information System Services</router-link></li>

                       </ul>
                   </div>
                   <div>
                       <h2 class="uk-heading-bullet">Services</h2>
                       <ul class="uk-list uk-list-bullet">
                           <li><router-link to="/careerservices">Career Services</router-link></li>
                           <li><router-link to="/unisscomputerlabs">Computer Labs</router-link></li>
                           <li><router-link to="/counsellingpsychology"> Counselling and Psychology</router-link></li>
                           <li><router-link to="/dentalhygiene">Dental Hygiene</router-link></li>
                           <li><router-link to="/fitnesscentre">Fitness Centre</router-link></li>
                           <li><router-link to="/healthwellness">Health & Wellness</router-link></li>
                           <li><router-link to="/internationalstudents">International Student Services</router-link></li>
                       </ul>
                   </div>
                   <div>
                       <h2 class="uk-heading-bullet">Subsidiaries</h2>
                       <ul class="uk-list uk-list-bullet">
                           <li class="uk-text-primary">NCU Day Care</li>
                           <li class="uk-text-primary">NCU Early Childhood Centre</li>
                           <li class="uk-text-primary">West Indies Preparatory</li>
                           <li class="uk-text-primary">Victor Dixon High School</li>
                           <li class="uk-text-primary">NCU Book Store</li>
                           <li class="uk-text-primary">University Press</li>
                           <li class="uk-text-primary">Aston and Novelette Tai Business Skills Centre
                           <ul class="uk-list-">
                               <li>- All Brands Superette</li>
                               <li>- Hilltop Hotel</li>
                           </ul>
                           </li>
                          <!-- <li class="uk-text-primary">Hilltop Hotel</li>-->
                           <li class="uk-text-primary">NCU Post Office</li>
                           <!--<li class="uk-text-primary">Suprette</li>-->
                       </ul>
                   </div>
               </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Pageheading from "../components/shared/pageheading";
    export default {
        name: "AdministrativeUnits",
        components: {Pageheading}
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h2{
            font-size: 1.1em !important;
        }
        p,li {
            font-size: 0.8em !important;

        }
    }
</style>
